<template>
  <div class="recipients">
    <b-row class="mb-3 mt-4">
      <b-col>
        <h2 class="mr-4 h3">Modtagere</h2>
      </b-col>
    </b-row>

    <b-pagination
      align="center"
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      class="mt-0"
    ></b-pagination>

    <b-alert class="mt-3 mb-3" style="white-space: break-spaces;" :show="alert !== null" :variant="alertVariant">
      {{alert}}
    </b-alert>

    <b-table
      striped
      hover
      responsive="md"
      :items="items"
      :fields="fields"
      :busy="loading"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
    >
      <template #empty>
        <div class="m-4">
          <p class="h5"><em>Der er ikke nogen nyhedsbrevsmodtagere at vise</em></p>
        </div>
      </template>
      <template #emptyfiltered>
        <div class="m-4">
          <p class="h5"><em>Filtreringen gav ingen resultater</em></p>
        </div>
      </template>
      <template #table-busy>
        <div style="height: 600px;" class="d-flex justify-content-around align-items-center">
          <b-spinner variant="primary"></b-spinner>
        </div>
      </template>
      <template v-slot:cell(confirmed)="item">
        <span
          class="font-weight-bold"
          :class="{
            'text-success': item.unformatted,
            'text-danger': !item.unformatted
          }">{{item.value}}</span>
      </template>
      <template v-slot:cell(ip_address)="item">
        <span :class="{'font-italic': item.unformatted === ''}">{{item.value}}</span>
      </template>
      <template v-slot:cell(confirmed_at)="item">
        <span :class="{'font-italic': item.unformatted === ''}">
          <template v-if="item.unformatted !== ''">{{item.value | moment('dddd DD. MMMM, YYYY')}}</template>
          <template v-else>{{item.value}}</template>
        </span>
      </template>
      <template v-slot:cell(actions)="row">
        <b-button size="sm" variant="primary" class="mr-2" :disabled="row.item.confirmed" @click="selectedUser = row" v-b-modal.modal-resend>
          <b-iconstack>
            <!-- <b-icon stacked icon="mailbox" scale="0.5"></b-icon> -->
            <b-icon stacked icon="arrow-clockwise" scale="1"></b-icon>
          </b-iconstack>
          <span class="hidden-text">Gensend bekræftelsesmail</span>
        </b-button> 
        <b-button size="sm" variant="secondary" @click="selectedUser = row" v-b-modal.modal-remove>
          <b-icon icon="trash-fill"></b-icon>
          <span class="hidden-text">Fjern modtager</span>
        </b-button>
      </template>
    </b-table>

    <b-pagination
      align="center"
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      class="mt-0"
    ></b-pagination>

    <b-modal id="modal-resend" title="Gensend bekræftelsesmail?" cancel-title="Nej" ok-title="Ja" cancel-variant="success" ok-variant="secondary" @ok="resendEmail(selectedUser.item.id)">
      <p class="my-4">Vil du gensende bekræftelsesemailen til <span v-if="selectedUser">{{ selectedUser.item.name }}</span></p>
    </b-modal>
    <b-modal id="modal-remove" title="Fjern modtager" cancel-title="Nej" ok-title="Ja" cancel-variant="success" ok-variant="secondary" @ok="removeRecipient(selectedUser)">
      <p class="my-4">Vil du fjerne modtageren <span v-if="selectedUser">{{ selectedUser.item.name }}</span></p>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'Recipients',
  components: { },
  data: () => ({
    loading: true,
    alert: null,
    alertVariant: 'danger',
    rows: 10,
    perPage: 25,
    currentPage: 1,
    sortBy: 'full_name',
    sortDesc: false,
    selectedUser: null,
    filter: '',
    timeout: null,
    items: [],
    fields: [
      {
        key: 'full_name',
        label: 'Fulde navn',
        sortable: false
      },
      {
        key: 'email',
        label: 'E-mailadresse',
        sortable: false
      },
      {
        key: 'confirmed',
        label: 'Bekræftet',
        sortable: false,
        formatter: (value) => {
          return value ? 'Ja' : 'Nej'
        },
      },
      {
        key: 'ip_address',
        label: 'IP-adresse',
        formatter: (value) => {
          return value ? value : 'Ikke tilgængelig'
        },
      },
      {
        key: 'confirmed_at',
        label: 'Dato',
        formatter: (value) => {
          return value ? value : 'Ikke tilgængelig'
        },
      },
      {
        key: 'actions',
        label: 'Handlinger',
        thStyle: 'opacity: 0;',
        class: 'text-right'
      }
    ]
  }),
  mounted() {
    this.getRecipients()
  },
  watch: {
    queryString: function () {
      clearTimeout(this.timeout)
      let that = this
      this.timeout = setTimeout(function () {
        that.getRecipients()
      }, 500)
    }
  },
  computed: {
    queryString() {
      return '?page=' + this.currentPage + '&query=' + this.filter + '&sortBy=' + this.sortBy + '&sortDesc=' + this.sortDesc
    },
    config() {
      return this.$store.getters.getConfig
    }
  },
  methods: {
    getRecipients() {
      this.loading = true
      this.axios.get('/api/recipients/' + this.queryString, this.config).then((response) => {
        this.items = response.data.results
        this.rows = response.data.count
        this.loading = false
      }).catch(error => {
        this.alert = 'Modtagerlisten kunne ikke hentes.\n\n' + error + '\n\nPrøv igen senere.'
        this.alertVariant = 'danger'
        this.loading = false
      })
    },
    removeRecipient(recipient) {
      this.alert = null
      this.axios.delete('/api/recipients/' + recipient.item.id, this.config).then((response) => {
        console.log(response)
        this.alert = 'Modtageren blev slettet.'
        this.alertVariant = 'success'
        this.getRecipients()
      }).catch(error => {
        this.alert = 'Modtageren kunne ikke slettes.\n\n' + error + '\n\nPrøv igen senere.'
        this.alertVariant = 'danger'
        this.loading = false
      })
    },
    resendEmail(id) {
      this.alert = null
      this.axios.post('/api/newsletters/actions/resend-confirmation-email', {id: id}, this.config).then((response) => {
        this.alert = 'Bekræftelsesmailen blev sendt.'
        this.alertVariant = 'success'
        console.log(response)
      }).catch(error => {
        this.alert = 'Bekræftelsesmailen kunne ikke gensendes.\n\n' + error + '\n\nPrøv igen senere.'
        this.alertVariant = 'danger'
      })
    }
  }
}
</script>

<style>

</style>